import { useMutation, useQuery } from '@tanstack/react-query';

import {
  type BffActivateUserRequest,
  Configuration,
  UsersApi,
} from '../../generated/api-client';
import { authenticateCredentials } from '../../network/apis/auth/auth';
import { bffServiceUrl } from '../../network/netconfig';

export interface ActivateFormData {
  email: string;
  password: string;
  confirmPassword: string;
  role: string;
  department: string;
}

export const useGetUserEmailByToken = (token: string) => {
  return useQuery({
    queryKey: ['user-email', token],
    queryFn: async () => {
      // Create configuration without authentication for the email endpoint
      const config = new Configuration({
        basePath: bffServiceUrl,
      });
      const usersApi = new UsersApi(config);
      const response = await usersApi.getUserEmailByToken({ token });

      return response.data;
    },
    enabled: !!token,
    throwOnError: false,
    retry: false,
  });
};

export const useActivateUser = () => {
  return useMutation({
    mutationFn: async (data: BffActivateUserRequest) => {
      try {
        const config = new Configuration({
          basePath: bffServiceUrl,
        });
        const usersApi = new UsersApi(config);

        // First, activate the user
        const activationResult = await usersApi.activateUser({
          bffActivateUserRequest: data,
        });

        // Then, automatically log them in
        await authenticateCredentials({
          email: data.email,
          password: data.password,
        });
        return activationResult;
      } catch (error) {
        console.error('Error during activation or login:', error);
        throw error;
      }
    },
    onSuccess: () => {
      // Use window.location.href to force a full page reload and re-initialize auth context
      window.location.href = '/';
    },
  });
};
